import { GetOneContentInDto, GetOneContentOutDto } from '../../../types/content.dto'

export const GET_ONE_CONTENT = 'GET_ONE_CONTENT'
export const GET_ONE_CONTENT_SUCCESS = 'GET_ONE_CONTENT_SUCCESS'
export const GET_ONE_CONTENT_ERROR = 'GET_ONE_CONTENT_ERROR'
export const RESET_GET_ONE_CONTENT = 'RESET_GET_ONE_CONTENT'

export interface GetOneContent {
  type: typeof GET_ONE_CONTENT
  payload: GetOneContentOutDto
}

export interface GetOneContentSuccess {
  type: typeof GET_ONE_CONTENT_SUCCESS
  payload: GetOneContentInDto
}

export interface GetOneContentError {
  type: typeof GET_ONE_CONTENT_ERROR
  payload: string | boolean
}

export interface ResetGetOneContent {
  type: typeof RESET_GET_ONE_CONTENT
  payload: null
}

export interface State {
  data: GetOneContentInDto | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetOneContent | GetOneContentSuccess | GetOneContentError | ResetGetOneContent
